import _ from 'lodash'
import flightService from '../../../../services/flightService'
import localisationService from '../../../../services/localisationService'
import moment from 'moment'

const state = {
  departureAirport: undefined,
  departureAirportEntries: [],
  departureAirportLoading: false,
  departureAirportValid: false,
  arrivalAirport: undefined,
  arrivalAirportEntries: [],
  arrivalAirportLoading: false,
  arrivalAirportValid: false,
  outwardDate: '',
  returnDate: '',
  calendarValid: false,
  classTypes: [],
  selectedClassType: undefined,
  selectedClassTypeValid: false,
  travelType: 'two-way',
  searchResultsTravelType: undefined,
  travellersValid: false,
  luggageOptions: [
    {
      value: '1',
      name: 'with-luggage'
    },
    {
      value: '0',
      name: 'without-luggage'
    },
    {
      value: 'no',
      name: 'indifferent'
    }
  ],
  selectedLuggageOption: 'no',
  itineraryPayload: undefined
}

const mutations = {
  // Departure airport
  changeDepartureAirport (state, newAirport) {
    state.departureAirport = newAirport
  },
  changeDepartureAirportEntries (state, newEntries) {
    state.departureAirportEntries = newEntries
  },
  resetDepartureAirportEntries (state) {
    state.departureAirportEntries = []
  },
  changeDepartureAirportLoading (state, loadingState) {
    state.departureAirportLoading = loadingState
  },
  changeDepartureAirportValidity (state, validity) {
    state.departureAirportValid = validity
  },
  // Arrival airport
  changeArrivalAirport (state, newAirport) {
    state.arrivalAirport = newAirport
  },
  changeArrivalAirportEntries (state, newEntries) {
    state.arrivalAirportEntries = newEntries
  },
  resetArrivalAirportEntries (state) {
    state.arrivalAirportEntries = []
  },
  changeArrivalAirportLoading (state, loadingState) {
    state.arrivalAirportLoading = loadingState
  },
  changeArrivalAirportValidity (state, validity) {
    state.arrivalAirportValid = validity
  },
  // Calendar
  changeOutwardDate (state, newDate) {
    state.outwardDate = newDate
  },
  changeReturnDate (state, newDate) {
    state.returnDate = newDate
  },
  changeCalendarValidity (state, validity) {
    state.calendarValid = validity
  },
  // Class type
  changeClassTypes (state, classTypes) {
    state.classTypes = classTypes
  },
  changeSelectedClassType (state, newClassType) {
    state.selectedClassType = newClassType
  },
  changeSelectedClassTypeValidity (state, newValidity) {
    state.selectedClassTypeValid = newValidity
  },
  // Travel type
  changeTravelType (state, newTravelType) {
    state.travelType = newTravelType
  },
  // Travellers
  changeTravellersValidity (state, validity) {
    state.travellersValid = validity
  },
  // Luggages
  changeSelectedLuggageOption (state, newSelectedLuggageOption) {
    state.selectedLuggageOption = newSelectedLuggageOption
  },
  changeItineraryPayload (state, newPayload) {
    state.itineraryPayload = newPayload
  }
}

const getters = {
  // Global
  parametersValidity (state, getters, rootState) {
    let validity = true
    if (!state.departureAirportValid) {
      validity = false
    }
    if (!state.arrivalAirportValid) {
      validity = false
    }
    if (!state.calendarValid) {
      validity = false
    }
    if (!state.travellersValid) {
      validity = false
    }
    if (!state.selectedClassTypeValid) {
      validity = false
    }
    if (!rootState.fb.searchFilters.schedulesFilterValidity) {
      validity = false
    }
    return validity
  }
}

const actions = {
  // Global
  swapAirports ({ commit, state }) {
    if (state.departureAirport && state.arrivalAirport) {
      // Have to clone deep both entries and airport state to avoid JS object pointer bug
      const departureAirport = _.cloneDeep(state.departureAirport)
      const departureAirportEntries = _.cloneDeep(state.departureAirportEntries)
      const arrivalAirport = _.cloneDeep(state.arrivalAirport)
      const arrivalAirportEntries = _.cloneDeep(state.arrivalAirportEntries)

      commit('changeDepartureAirport', arrivalAirport)
      commit('changeDepartureAirportEntries', arrivalAirportEntries)
      commit('changeArrivalAirport', departureAirport)
      commit('changeArrivalAirportEntries', departureAirportEntries)
    }
  },
  constructSearchPayload ({ state, commit, rootState }) {
    const payload = {
      class_type: state.selectedClassType.class_type,
      from_search: {
        place_type: 'Airport',
        code: state.departureAirport.iata_code,
        name: state.departureAirport.name,
        city: state.departureAirport.city_name,
        country: state.departureAirport.country.name
      },
      to_search: {
        place_type: 'Airport',
        code: state.arrivalAirport.iata_code,
        name: state.arrivalAirport.name,
        city: state.arrivalAirport.city_name,
        country: state.arrivalAirport.country.name
      },
      begin: state.outwardDate
    }

    if (rootState.fb.searchFilters.selectedStopover === null) {
      payload.max_connections = 'manystopover'
    } else {
      payload.max_connections = rootState.fb.searchFilters.selectedStopover
    }

    if (state.returnDate !== '') {
      payload.end = state.returnDate
    }

    if (state.selectedLuggageOption === '1') {
      payload.luggages = '1'
    } else if (state.selectedLuggageOption === '0') {
      payload.luggages = '0'
    }

    const nbTravellers = []
    const nbTravellersTmp = []

    for (const traveller of rootState.fb.passengersInformation.searchParametersTravellers) {
      if (nbTravellersTmp[traveller.traveller_type]) {
        nbTravellersTmp[traveller.traveller_type] = nbTravellersTmp[traveller.traveller_type] + 1
      } else {
        nbTravellersTmp[traveller.traveller_type] = 1
      }
    }
    // console.log('construct search payload nbTravellersTmp : ', nbTravellersTmp)

    for (var key in nbTravellersTmp) {
      nbTravellers.push({ number: nbTravellersTmp[key], traveller_type: key })
    }

    // console.log('construct search payload nbTravellers : ', nbTravellers)

    payload.nb_travellers = nbTravellers

    const beginHourDelta = rootState.fb.searchFilters.outwardFlightDepartureDelta
    if (beginHourDelta.begin !== 0 || beginHourDelta.end !== 24) {
      const begin = moment(beginHourDelta.begin, 'HH')
      const end = moment(beginHourDelta.end, 'HH')
      payload.begin_hour_delta = {
        begin: begin.format('HH:mm'),
        end: end.format('HH:mm')
      }
    }

    const endHourDelta = rootState.fb.searchFilters.returnFlightDepartureDelta
    if (endHourDelta.begin !== 0 || endHourDelta.end !== 24) {
      const begin = moment(endHourDelta.begin, 'HH')
      const end = moment(endHourDelta.end, 'HH')
      payload.end_hour_delta = {
        begin: begin.format('HH:mm'),
        end: end.format('HH:mm')
      }
    }

    const selectedAirlineCompanies = rootState.fb.searchFilters.selectedAirlineCompanies
    if (selectedAirlineCompanies.length > 0) {
      payload.white_list = selectedAirlineCompanies
    }

    payload.for_revalidate = true

    commit('changeItineraryPayload', payload)
  },
  changeSearchResultsStates ({ state, commit }) {
    commit('fb/searchResults/changeDepartureAirport', state.departureAirport, { root: true })
    commit('fb/searchResults/changeArrivalAirport', state.arrivalAirport, { root: true })
    commit('fb/searchResults/changeOutwardDate', state.outwardDate, { root: true })
    commit('fb/searchResults/changeReturnDate', state.returnDate, { root: true })
    commit('fb/searchResults/changeClassType', state.selectedClassType, { root: true })
    commit('fb/searchResults/changeTravelType', state.travelType, { root: true })
    commit('fb/searchResults/changeTravellers', state.selectedTravellers, { root: true })
    commit('fb/searchResults/changeLuggageOption', state.selectedLuggageOption, { root: true })
  },
  searchDepartureAirports: _.debounce(async ({ commit }, payload) => {
    commit('changeDepartureAirportLoading', true)
    commit('resetDepartureAirportEntries')
    /*
    Entries need to be reset each time a search is done,
    because the autocomplete component will add more and more entries
    to the array every time the user add a letter to the search input
    */
    const tempArray = []
    try {
      const response = await localisationService.getAirport(payload)
      for (const airport of response.data) {
        tempArray.push(airport)
      }
      commit('changeDepartureAirportEntries', tempArray)
      commit('changeDepartureAirportLoading', false)
    } catch (error) {
      commit('changeDepartureAirportLoading', false)
    }
  }, 600),
  searchArrivalAirports: _.debounce(async ({ commit }, payload) => {
    commit('changeArrivalAirportLoading', true)
    commit('resetArrivalAirportEntries')
    /*
    Entries need to be reset each time a search is done,
    because the autocomplete component will add more and more entries
    to the array every time the user add a letter to the search input
    */
    const tempArray = []
    try {
      const response = await localisationService.getAirport(payload)
      for (const airport of response.data) {
        tempArray.push(airport)
      }
      commit('changeArrivalAirportEntries', tempArray)
      commit('changeArrivalAirportLoading', false)
    } catch (error) {
      commit('changeArrivalAirportLoading', false)
    }
  }, 600),
  async initClassTypes ({ commit }) {
    const response = await flightService.getClassTypes()
    commit('changeClassTypes', response.data.class_types)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
